import { Autocomplete, TextField } from '@mui/material';
import { useMemo } from 'react';

export const ALL_PRODUCTS_OPTION = { id: 'TODOS', nombre: 'Todos los productos' };

export default function ProductoFilterAutocomplete({
  productos = [],
  value = 'TODOS',
  onChange,
  label = 'Producto',
  allLabel = 'Todos los productos',
  size = 'small',
  sx,
  fullWidth = false,
}) {
  const options = useMemo(() => {
    const sorted = [...productos].sort((a, b) =>
      (a.nombre || '').localeCompare(b.nombre || '', 'es', { sensitivity: 'base' })
    );
    return [{ id: 'TODOS', nombre: allLabel }, ...sorted];
  }, [productos, allLabel]);

  const selected = options.find((o) => o.id === value) || options[0];

  return (
    <Autocomplete
      size={size}
      fullWidth={fullWidth}
      options={options}
      value={selected}
      onChange={(_, option) => onChange(option?.id || 'TODOS')}
      getOptionLabel={(option) => option?.nombre || ''}
      isOptionEqualToValue={(a, b) => a.id === b.id}
      filterOptions={(opts, { inputValue }) => {
        const q = inputValue.trim().toLowerCase();
        if (!q) return opts;
        return opts.filter((o) => (o.nombre || '').toLowerCase().includes(q));
      }}
      noOptionsText="Sin coincidencias"
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder="Buscar producto..." />
      )}
      ListboxProps={{ style: { maxHeight: 280 } }}
      sx={{ minWidth: 220, ...sx }}
    />
  );
}
